import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'select' };

class FormSelect extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__input',
            className,
        ];
    }

}

FormSelect.propTypes = propTypes;

FormSelect.defaultProps = defaultProps;

export default FormSelect;
